import React from "react";
import Checkbox from "../../components/base/checkbox";
export default Checkbox;